document.addEventListener('DOMContentLoaded', async () => {

    const overlay = document.getElementById('overlay')
    const overlayContainer = document.getElementById('overlay-container')
    const closeOverlay = document.getElementById('close-overlay')

    if (overlay && overlayContainer && closeOverlay) {

        closeOverlay.addEventListener('click', () => {
            overlay.classList.add('hidden');
        });

        // close overlay when clicking outside of actual overlay
        overlay.addEventListener("click", (event) => {
            const clickedOutside = !overlayContainer.contains(event.target);
            if (clickedOutside) {
                overlay.classList.add("hidden");
            }
        });
    }

    // if wp/core button has class js__overlay add data-open-overlay attribute to its <a> child
    document.querySelectorAll('.wp-block-button[class*="js__overlay-"]').forEach(el => {
        const link = el.querySelector('a');
        if (!link) return;
        el.classList.forEach(cls => {
            if (cls.startsWith('js__overlay-')) {
                link.setAttribute('data-open-overlay', cls.replace('js__overlay-', ''));
            }
        });
    });

    // to add an overlay use the overlaycomponent with prop overlayContent = name of partial that should be displayed inside the overlay
    // for the opening trigger add data-open-overlay attr to the button/element with the same partial as value
    document.addEventListener("click", function (event) {
        const openButton = event.target.closest("[data-open-overlay]");
        if (!openButton) return;

        const overlayName = openButton.getAttribute("data-open-overlay");

        const openOverlay = document.querySelector(`[data-overlay="${overlayName}"]`);

        if (openOverlay) {
            openOverlay.classList.remove("hidden");
        }
    });
});
